<div class="chat-main-content" [class.history-open]="!windowService.isDesktopRes && historyPanelOpen()">
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      class="mobile"
      [canGoBack]="false"
      [title]="'Chat'"
      [closeIconMobile]="'chatbubbles-outline-white'"
      [closeIconSrc]="chatbubblesIconUri"
      (closeItemAction)="onMenuClick()"
      [showLinkIcon]="true"
      [linkIcon]="'create'"
      [linkIconSrc]="createIconUri"
      (linkAction)="onNewChat()" />
  }

  <ng-template #content>
    <tidy-wrapper [hasBottomNav]="!windowService.isDesktopRes" [isPrimaryLayer]="true" class="chat-page-wrapper flex-content">

      @if (windowService.isDesktopRes) {
        <tidy-desktop-header class="chat-desktop-header" [isLoading]="chat()?.isLoading() ?? true">
          <div class="wrappable-container">
            <tidy-text [title]="'Chat'" />
            @if (chat() && !chat()!.isLoading()) {
              <tidy-header-select
                class="chat-session-select"
                [items]="chat()!.sessionSelectItems()"
                [selectedValue]="chat()!.currentSessionId()?.toString() ?? ''"
                [richItems]="true"
                [showItemActions]="true"
                [editable]="true"
                [isEditing]="chat()!.editingSubject()"
                [editingValue]="chat()!.editingSubjectValue()"
                [placeholder]="'New Chat'"
                (optionChange)="chat()!.onSessionSelected($event)"
                (editItem)="chat()!.onEditSessionItem($event)"
                (deleteItem)="chat()!.onDeleteSessionItem($event)"
                (editingValueChange)="chat()!.editingSubjectValue.set($event)"
                (editSave)="chat()!.saveSubject()"
                (editCancel)="chat()!.cancelEditingSubject()" />
            }
            @if (!chat()?.isCreatingNewChat()) {
              <tidy-small-button
                [text]="'New Chat'"
                [image]="addButtonIconUri"
                (buttonClick)="chat()?.createNewSession()" />
            }
            @if (chat()?.isManualRefreshing()) {
              <ion-spinner name="lines" class="chat-refresh-spinner" />
            }
          </div>
          <div class="non-wrappable-right-aligned-container">
            <automations-preview-button
              [tag]="'chat'" />
          </div>
        </tidy-desktop-header>
      }

      <tidy-expandable-chat [isFullPage]="true" class="flex-fill" />

    </tidy-wrapper>
  </ng-template>

  <app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />

  @if (!isKeyboardVisible()) {
    <tidy-bottom-nav activeRoute="/chat" />
  }
</div>

@if (!windowService.isDesktopRes) {
  <div class="chat-history-panel" [class.open]="historyPanelOpen()">
    <tidy-top-nav
      class="mobile"
      [canGoBack]="false"
      [noBow]="true"
      [title]="'Chat History'"
      [showLinkIcon]="true"
      [linkIcon]="'chevron-forward'"
      (linkAction)="onHistoryPanelToggle(false)" />

    <div class="history-panel-list">
      <div class="history-search-top">
        <tidy-search-input
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          [fixedWidth]="false"
          class="header-search full-width"
          (valueChange)="chat()?.historySearchQuery?.set($event)" />
      </div>
      @if (chat(); as c) {
        @for (item of c.filteredSessionItems(); track item.value) {
          <button
            class="history-item"
            [class.active]="item.value === c.currentSessionId()?.toString()"
            (click)="onHistorySessionSelect(item.value)">
            <div class="history-item-content">
              <tidy-text [body]="item.viewValue.length > 45 ? item.viewValue.substring(0, 45) + '..' : item.viewValue" />
            </div>
            <span class="history-item-date">{{ item.metadata }}</span>
          </button>
        }
        @if (c.filteredSessionItems().length === 0 && c.historySearchQuery()) {
          <div class="history-empty">No conversations found</div>
        }
        @if (c.isLoading() && c.sessions().length === 0) {
          <div class="history-empty">Loading...</div>
        }
      }
    </div>
  </div>
}
